import { Component, forwardRef, Injector, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { LogBookUser, LogUser } from "ng/src/app/users/shared/user.model";
import { BehaviorSubject } from "rxjs";
import { UserService } from "ng/src/app/users/shared/user.service";
import { BaseComponent } from "ng/src/app/shared/base.component";
import { filter, map, switchMap, takeUntil } from "rxjs/operators";

@Component({
	selector: 'lb-user-list-selector[logId][type]',
	template: `
		<p-listbox [options]="options" [(ngModel)]="value" [multiple]="true" [checkbox]="true" [showToggleAll]="true" dataKey="id">
			<ng-template pTemplate="item" let-user>
				<div>
					<span>{{getDisplayValue(user)}}</span>
				</div>
			</ng-template>
		</p-listbox>
	`,
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: forwardRef(() => LogbookUserListSelectorComponent)
	}]
})
export class LogbookUserListSelectorComponent extends BaseComponent implements OnInit, ControlValueAccessor {
	@Input()
	set logId(val: number) {
		this.logIdSubject.next(val);
	}
	
	@Input() type!: 'logUser' | 'logBookUser'
	
	options: (LogBookUser | LogUser)[] = [];
	
	private _value: (LogBookUser | LogUser)[] = [];
	
	onChange?: (val: any) => void;
	onTouched?: () => void;
	disabled = false;
	
	private readonly logIdSubject = new BehaviorSubject<number | null>(null);
	
	constructor(
		private userService: UserService,
		injector: Injector
	) {
		super(injector);
	}
	
	
	ngOnInit(): void {
		this.logIdSubject.pipe(
			takeUntil(this.onDestroy$),
			filter(log => !!log),
			switchMap(log => {
				return this.userService.fetchLogUsers({ log: log!, sort: ['user.lastName,asc', 'user.firstName,asc'] })
			}),
			map(res => res.map(u => this.type === 'logUser' ? u : u.user))
		)
			.subscribe(users => this.options = users);
	}
	
	get value() {
		return this._value;
	}
	
	set value(val) {
		this.writeValue(Array.isArray(val) ? val : [])
	}
	
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
	
	writeValue(val: (LogBookUser | LogUser)[]): void {
		val = Array.isArray(val) ? val : [];
		
		this._value = val;
		this.onChange?.(val);
	}
	
	getDisplayValue(val: LogBookUser | LogUser) {
		return this.useLogBookUser(val) ? `${val.firstName} ${val.lastName}` : `${val.user.firstName} ${val.user.lastName}`;
	}
	
	private useLogBookUser(val: LogBookUser | LogUser): val is LogBookUser {
		return this.type === 'logBookUser';
	}
}